import { DATA_SERVICE_BASE_URL } from '../ApiService';
import { fetchWithAuth } from '../AuthService';

/**
 * Alert API — admin endpoints for managing alert rules and viewing alert history.
 */
export const AlertApi = {

  /** Get all alert rules (active + inactive). */
  async getRules() {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/alerts/rules`);
    if (!res.ok) throw new Error(`Failed to fetch alert rules: ${res.status}`);
    return res.json();
  },

  /** Create a new alert rule. */
  async createRule(rule) {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/alerts/rules`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(rule),
    });
    if (!res.ok) throw new Error(`Failed to create alert rule: ${res.status}`);
    return res.json();
  },

  /** Deactivate (soft-delete) an alert rule. */
  async deactivateRule(ruleId) {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/alerts/rules/${ruleId}`, {
      method: 'DELETE',
    });
    if (!res.ok) throw new Error(`Failed to deactivate alert rule: ${res.status}`);
  },

  /** Get paginated alert history. */
  async getHistory(page = 0, size = 20) {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/alerts/history?page=${page}&size=${size}`);
    if (!res.ok) throw new Error(`Failed to fetch alert history: ${res.status}`);
    return res.json();
  },

  /** Get unacknowledged alerts (for notification badge + panel). */
  async getUnacknowledged(page = 0, size = 10) {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/alerts/unacknowledged?page=${page}&size=${size}`);
    if (!res.ok) throw new Error(`Failed to fetch unacknowledged alerts: ${res.status}`);
    return res.json();
  },

  /** Acknowledge a single alert. */
  async acknowledgeAlert(alertId) {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/alerts/acknowledge/${alertId}`, {
      method: 'POST',
    });
    if (!res.ok) throw new Error(`Failed to acknowledge alert: ${res.status}`);
  },

  /** Acknowledge all alerts. */
  async acknowledgeAll() {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/alerts/acknowledge-all`, {
      method: 'POST',
    });
    if (!res.ok) throw new Error(`Failed to acknowledge all alerts: ${res.status}`);
  },

  /** Manually trigger alert evaluation (admin testing). */
  async evaluate() {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/alerts/evaluate`, {
      method: 'POST',
    });
    if (!res.ok) throw new Error(`Failed to trigger alert evaluation: ${res.status}`);
    return res.json();
  },
};
